import { render, staticRenderFns } from "./LjReportList.vue?vue&type=template&id=6cad8078&scoped=true"
import script from "./LjReportList.vue?vue&type=script&lang=js"
export * from "./LjReportList.vue?vue&type=script&lang=js"
import style0 from "./LjReportList.vue?vue&type=style&index=0&id=6cad8078&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cad8078",
  null
  
)

export default component.exports